import { fetcherPOST } from "../../infra/api";
import { PREDRAFT_EMAIL } from "../../const/Internal";
import { getEnvironmentConfig } from "../../utils/Environment";
import { ISuccessApiResponse } from "../../types/api/endpoints/ISuccessApiResponse";

async function sendFeedback(
  userId: string,
  userEmail: string,
  textBody: string,
  emailData: { [key: string]: string } = {}
): Promise<ISuccessApiResponse> {
  textBody += `\n\n${Object.entries(emailData)
    .map(([key, value]) => `${key}: ${value}`)
    .join("\n")}`;

  return fetcherPOST<ISuccessApiResponse>(`/api/email`, {
    from: PREDRAFT_EMAIL,
    to: getEnvironmentConfig(PREDRAFT_EMAIL, userEmail),
    subject: `Predraft Feedback: ${userEmail} ${
      emailData?.article_id ? `- ${emailData?.article_id}` : ""
    }`,
    text_body: textBody,
  });
}

async function sendContactLead(data: {
  userId: string;
  name: string;
  email: string;
  company: string;
  message: string;
}) {
  let { userId, name, email, company, message } = data;
  message += `\n\nName: ${name}\ncompany: ${company}\nUser ID: ${userId}\nUser email: ${email}`;
  return fetcherPOST<ISuccessApiResponse>(`/api/email`, {
    from: PREDRAFT_EMAIL,
    to: PREDRAFT_EMAIL,
    subject: `Predraft Contact Lead: ${email}`,
    text_body: message,
  });
}

async function sendEnterprisePlan(
  userId: string,
  name: string,
  email: string,
  company: string,
  seats: number,
  message: string
): Promise<ISuccessApiResponse> {
  message += `\n\nName: ${name}\nCompany: ${company}\nSeats: ${seats}\nUser ID: ${userId}\nUser email: ${email}`;
  return fetcherPOST<ISuccessApiResponse>(`/api/email`, {
    from: PREDRAFT_EMAIL,
    to: getEnvironmentConfig(PREDRAFT_EMAIL, email),
    subject: `Predraft Enterprise Plan Interest: ${email}`,
    text_body: message,
  });
}

export const EmailAPI = {
  sendFeedback,
  sendContactLead,
  sendEnterprisePlan,
};
